import React, { useState } from 'react';
import { getBgColorStyleValue } from '../utils/checklistUtils';

interface Topic {
  title: string;
  link: string;
  completed: boolean;
  checklistNameFormat: string;
}

interface ChecklistItemProps {
  title: string;
  description: string;
  percentage: number;
  imageUrl: string;
  topics: Topic[];
  toggleId: number;
  icon: string;
}

const ChecklistItem: React.FC<ChecklistItemProps> = ({ 
  title, 
  description, 
  percentage, 
  imageUrl, 
  topics, 
  toggleId, 
  icon
}) => {
  const [expanded, setExpanded] = useState(false);

  const toggleVisibility = () => {
    setExpanded(!expanded);
  };

  const bgColorStyleValue = getBgColorStyleValue(percentage);
  // console.log(topics);
  return (
    <li 
      className="checklist-item" 
      style={{ '--percentage': percentage } as React.CSSProperties} 
      data-percentage={percentage} 
    >
      <div className="checklist-image">
        <img width="40" height="40" alt="checklist icon" src={imageUrl} />
      </div>
      <div className="checklist-body w-100">
        <h2 className="visibility_toggle_alt" data-toggle-id={toggleId}>
          {title}
        </h2>
        <p className="size-large">{description}</p>
        <div className="checklist-progress">
          <span>{`Topics ${topics.filter(topic => topic.completed).length}/${topics.length}`}</span>
          <span className="progress-bar" style={{ '--percentage': bgColorStyleValue } as React.CSSProperties}></span>
          <span>{`${percentage}%`}</span>
        </div>
        <ul 
          className={`checklist-topics visibility_toggled ${expanded ? '' : 'd-none'}`}
          aria-expanded={expanded}
          aria-hidden={!expanded}
          data-toggle-id={toggleId}
        >
          {topics
          .map((topic, index) => (
            <li key={index} className="d-flex gap-3 align-items-center" id={topic.checklistNameFormat}>
              <span className={topic.completed ? 'completed' : 'incomplete'}></span>
              <a className="underline-not-hover" href={topic.link}>
                <h4>{topic.title}</h4>
                <span className="arrow-right"></span>
              </a>
            </li>
          ))}
        </ul>
      </div>
      <img src={icon} alt="icon" width={40} height={40} className="expand-collapse visibility_toggle" 
        data-toggle-id={toggleId} 
        aria-expanded={expanded} 
        onClick={toggleVisibility} />
        {/* below code not supported with Vite */}
      <span 
        className="expand-collapse visibility_toggle d-none" 
        data-toggle-id={toggleId} 
        aria-expanded={expanded} 
        onClick={toggleVisibility} 
        style={{ backgroundImage: `url("${encodeURIComponent(icon)}")` }}

      ></span>
      

    </li>
  );
};

export default ChecklistItem;
